$(document).ready(function(){    
    $('.step__button').click(function(e) { 
        e.preventDefault();
        var currentUrl = $(this).attr("action");
        var $currentPath = currentUrl.match(/^(\/[^?]+)/)[1];

        var $finderStepMatch = currentUrl.match(/(?:&|\?)step=(\d+|results)/);
        var $finderStep = $finderStepMatch ? $finderStepMatch[1] : null;

        var $finderNameMatch = currentUrl.match(/pfID=([^&_-]+)/);
        var $finder = $finderNameMatch ? $finderNameMatch[1] : null;
        var $finderName= capitalizeFirstLetter($finder);
        function capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }

        window.dataLayer.push({
            "event": "virtualPageview",
            "page": $currentPath+"-"+$finder+"/"+$finderStep,
            "finderName": $finderName
        });

        $(document).on('click', '.step__answer--next_on_click', function(e) {
            e.preventDefault();
            var answerData = $(this).attr("data-answer-id");
            var choice = $(this).attr("aria-label");
            var matches = answerData.match(/\d+/g);
        
            var question = parseInt(matches[0], 10)+2;
        
            if (question == 4) {
                window.dataLayer.push({
                    "event": "virtualPageview",
                    "page": $currentPath+"-"+$finder+"/results",
                    "finderName": $finderName
                });
                window.dataLayer.push({ 
                    "event": "productFinderChoice", 
                    "finderStep": question-1, 
                    "finderChoice": choice
                });
            } else {
                window.dataLayer.push({
                    "event": "virtualPageview",
                    "page": $currentPath+"-"+$finder+"/"+question,
                    "finderName": $finderName
                });

                window.dataLayer.push({ 
                    "event": "productFinderChoice", 
                    "finderStep": question-1, 
                    "finderChoice": choice
                });
            }
            
        });
    });
    
});
$(document).on( 'click', '.start-over', function(e){
    e.preventDefault();
    window.dataLayer.push({
        "event": "productFinderClick",
        "ctaName": "Start Over"
    });
});

